import React from "react";
import { cn } from "@/lib/utils";
import QuestionCard from "./QuestionCard";
import QuestionDetailPanel from "./QuestionDetailPanel";

// ── Loading Skeleton ───────────────────────────────────────────────────
const QuestionCardSkeleton = () => (
  <div className="h-40 rounded-lg border bg-muted animate-pulse" />
);

// ── Question List ──────────────────────────────────────────────────────
const QuestionList = ({
  questions,
  loading,
  selectedQuestion,
  onSelectQuestion,
  onCloseDetail,
  onToggleFavourite,
  onEdit,
  onDuplicate,
  onArchive,
  onDelete,
}) => {
  return (
    <div className="flex gap-4 items-start">
      {/* ── Grid ── */}
      <div
        className={cn(
          "grid gap-4 min-w-0 flex-1",
          selectedQuestion
            ? "grid-cols-2"
            : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
        )}
      >
        {loading
          ? Array.from({ length: 6 }).map((_, i) => (
              <QuestionCardSkeleton key={i} />
            ))
          : questions.map((question) => (
              <QuestionCard
                key={question._id}
                question={question}
                isSelected={selectedQuestion?._id === question._id}
                onSelect={onSelectQuestion}
                onToggleFavourite={onToggleFavourite}
                onEdit={onEdit}
              />
            ))}
      </div>

      {/* ── Detail Panel ── */}
      {selectedQuestion && (
        <div className="w-[420px] shrink-0 sticky top-4 self-start">
          {" "}
          {/* ✅ wider panel */}
          <QuestionDetailPanel
            question={selectedQuestion}
            onClose={onCloseDetail}
            onEdit={(q) => {
              onEdit(q);
              onCloseDetail();
            }}
            onDuplicate={onDuplicate}
            onArchive={onArchive}
            onDelete={onDelete}
            onToggleFavourite={onToggleFavourite}
          />
        </div>
      )}
    </div>
  );
};

export default QuestionList;
